import { render, staticRenderFns } from "./template/slip-info-modal.html?vue&type=template&id=77901520&external"
import script from "./SlipInfoModal.vue?vue&type=script&lang=js"
export * from "./SlipInfoModal.vue?vue&type=script&lang=js"
import style0 from "./SlipInfoModal.vue?vue&type=style&index=0&id=77901520&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports